import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_ALLOWED_STATE_SAVED = gql`
  subscription documentTypeAllowedStateSaved {
    documentTypeAllowedStateSaved {
      id
      documentTypeId
    }
  }
`;
